module.exports = __webpack_public_path__ + "img/badge-list-thumb-053.ab68125e.png";